import getSelectedTableView from '../../utils/getSelectedTableView';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setMultiSelectPerfDatapoint', multiSelectPerfDatapoint => {
    const tableView = getSelectedTableView();
    tableView.multiSelectPerfDatapoint = multiSelectPerfDatapoint;
});
